import axios from 'axios';

class loginService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    checkCredentials(params) {
        return axios
            .post(this.state.apiUrl + 'session/login', JSON.stringify(params), {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => {
                return res.data;
            });
    }

    async sendForgotPasswordEmail(email) {
        return axios
            .post(
                this.state.apiUrl + 'session/forgotPassword',
                { email: email },
                { 'Content-Type': 'application/json' },
            )
            .then((res) => {
                return res.data;
            });
    }

    async resetPassword(token, new_password, new_password_repeated) {
        const url = this.state.apiUrl + `session/resetPasswordSubmit`;
        if (url.includes(this.state.apiUrl + `session/resetPasswordSubmit`)) {
            return axios
                .post(
                    url,
                    {
                        token: token,
                        newPassword: new_password,
                        newPasswordRepeated: new_password_repeated,
                    },
                    { 'Content-Type': 'application/json' },
                )
                .then((res) => {
                    return res.data;
                });
        }
    }
}

export default loginService;

